import { AlertTriangle } from "lucide-react";
import type { DailyEntryWarning } from "@crewledger/shared/daily-entry/row-warnings";
import { cn } from "@/lib/utils";

interface RowWarningsListProps {
  warnings: DailyEntryWarning[];
  className?: string;
  compact?: boolean;
}

export function RowWarningsList({ warnings, className, compact = false }: RowWarningsListProps) {
  if (warnings.length === 0) return null;

  return (
    <ul className={cn("space-y-0.5", className)}>
      {warnings.map((warning, index) => (
        <li
          key={`${warning.code}-${index}`}
          className={cn(
            "flex items-start gap-1",
            compact ? "text-[10px]" : "text-xs",
            warning.severity === "error" ? "text-red-700" : "text-amber-800",
          )}
        >
          <AlertTriangle className={cn("mt-0.5 shrink-0", compact ? "h-3 w-3" : "h-3.5 w-3.5")} />
          <span>{warning.message}</span>
        </li>
      ))}
    </ul>
  );
}
